import Accordion from './accordion.js';
import AddClass from './add_class.js';
import Arch from './arch.js';
import Contact from './contact.js';
import Entry from './entry.js';
import MegaNav from './mega-nav.js';
import Nav from './nav.js';
import MySwiper from './my_swiper.js';
import Modal from './modal.js';
import YoutubeFacade from './youtube-facade.js';
import PageFollow from './page_follow.js';
import LogoColorChange from './logo-color-change.js';
import SmoothScroll from './smooth_scroll.js';


export default class Common {
  constructor() {
    this.swiperBaseElems = document.querySelectorAll('.js-swiper_base, .js-swiper_lower, .js-swiper_pickup');
    this.mySwiper = [];

    this.init();
  }

  init() {
    this.resetScrollOnReload();
    this.megaNav = new MegaNav();
    this.accordion = new Accordion();
    this.arch = new Arch();
    this.contact = new Contact();
    this.entry = new Entry();
    this.addClass = new AddClass();
    this.nav = new Nav();
    this.Modal = new Modal();
    this.YoutubeFacade = new YoutubeFacade();
    this.PageFollow = new PageFollow();
    this.LogoColorChange = new LogoColorChange();
    this.SmoothScroll = new SmoothScroll();
    
    this.initBaseSwiper();
  }

  initBaseSwiper() {
    this.swiperBaseElems.forEach(elem => {
      const instance = new MySwiper(elem);
      this.mySwiper.push(instance);
    });
  }

  resetScrollOnReload() {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const [navigationEntry] = performance.getEntriesByType('navigation');
    if (navigationEntry?.type === 'reload') {
      window.scrollTo(0, 0);
    }
  }
}
